// Mock data for youseful.shop

export const mockProducts = [
  {
    id: '1',
    name: 'Wireless Noise-Cancelling Headphones',
    category: 'Electronics',
    description: 'Premium wireless headphones with active noise cancellation, 30-hour battery life, and studio-quality sound.',
    price: 2499,
    originalPrice: 8999,
    image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NjEzMzU3Mzd8MA&ixlib=rb-4.1.0&q=85',
    designer: 'Rajesh Kumar',
    inStock: true,
    rating: 4.7,
    reviews: 234,
    costBreakdown: {
      manufacturing: 1200,
      quality: 200,
      logistics: 300,
      platform: 799
    }
  },
  {
    id: '2',
    name: 'Smart LED Desk Lamp',
    category: 'Electronics',
    description: 'App-controlled LED desk lamp with adjustable brightness, color temperature, and built-in wireless charging.',
    price: 1299,
    originalPrice: 4999,
    image: 'https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg',
    designer: 'Priya Sharma',
    inStock: true,
    rating: 4.5,
    reviews: 187,
    costBreakdown: {
      manufacturing: 600,
      quality: 150,
      logistics: 200,
      platform: 349
    }
  },
  {
    id: '3',
    name: 'Premium Cotton T-Shirt',
    category: 'Apparel',
    description: '100% organic cotton t-shirt with modern fit. Breathable, durable, and ethically manufactured.',
    price: 399,
    originalPrice: 1499,
    image: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxmYXNoaW9ufGVufDB8fHx8MTc2MTMzMjYzOHww&ixlib=rb-4.1.0&q=85',
    designer: 'Ananya Desai',
    inStock: true,
    rating: 4.8,
    reviews: 456,
    costBreakdown: {
      manufacturing: 180,
      quality: 40,
      logistics: 80,
      platform: 99
    }
  },
  {
    id: '4',
    name: 'Designer Denim Jacket',
    category: 'Apparel',
    description: 'Classic denim jacket with modern cuts. Premium fabric with reinforced stitching.',
    price: 1899,
    originalPrice: 6999,
    image: 'https://images.pexels.com/photos/794064/pexels-photo-794064.jpeg',
    designer: 'Vikram Singh',
    inStock: true,
    rating: 4.6,
    reviews: 312,
    costBreakdown: {
      manufacturing: 900,
      quality: 200,
      logistics: 250,
      platform: 549
    }
  },
  {
    id: '5',
    name: 'Modern Ceramic Vase Set',
    category: 'Home Furnishings',
    description: 'Handcrafted ceramic vase set with minimalist design. Perfect for contemporary homes.',
    price: 799,
    originalPrice: 2999,
    image: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxob21lJTIwZGVjb3J8ZW58MHx8fHwxNzYxMzc5MzQ0fDA&ixlib=rb-4.1.0&q=85',
    designer: 'Kavita Patel',
    inStock: true,
    rating: 4.9,
    reviews: 178,
    costBreakdown: {
      manufacturing: 350,
      quality: 80,
      logistics: 150,
      platform: 219
    }
  },
  {
    id: '6',
    name: 'Decorative Wall Mirror',
    category: 'Home Furnishings',
    description: 'Premium quality wall mirror with elegant frame. Adds depth and style to any room.',
    price: 1499,
    originalPrice: 5499,
    image: 'https://images.pexels.com/photos/1099816/pexels-photo-1099816.jpeg',
    designer: 'Arjun Mehta',
    inStock: true,
    rating: 4.7,
    reviews: 203,
    costBreakdown: {
      manufacturing: 700,
      quality: 150,
      logistics: 250,
      platform: 399
    }
  },
  {
    id: '7',
    name: 'Ergonomic Office Chair',
    category: 'Furniture',
    description: 'Premium ergonomic chair with lumbar support, adjustable height, and breathable mesh back.',
    price: 4999,
    originalPrice: 18999,
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxmdXJuaXR1cmV8ZW58MHx8fHwxNzYxNDQwMjIzfDA&ixlib=rb-4.1.0&q=85',
    designer: 'Suresh Reddy',
    inStock: true,
    rating: 4.8,
    reviews: 567,
    costBreakdown: {
      manufacturing: 2400,
      quality: 500,
      logistics: 800,
      platform: 1299
    }
  },
  {
    id: '8',
    name: 'Modern Sofa Set',
    category: 'Furniture',
    description: 'Luxurious 3-seater sofa with premium fabric, solid wood frame, and contemporary design.',
    price: 24999,
    originalPrice: 89999,
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxmdXJuaXR1cmV8ZW58MHx8fHwxNzYxNDQwMjIzfDA&ixlib=rb-4.1.0&q=85',
    designer: 'Meera Iyer',
    inStock: true,
    rating: 4.9,
    reviews: 289,
    costBreakdown: {
      manufacturing: 12000,
      quality: 2500,
      logistics: 4000,
      platform: 6499
    }
  }
];

export const mockCategories = [
  {
    id: '1',
    name: 'Electronics',
    image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljc3xlbnwwfHx8fDE3NjEzMzU3Mzd8MA&ixlib=rb-4.1.0&q=85',
    description: 'Cutting-edge gadgets and electronics'
  },
  {
    id: '2',
    name: 'Apparel',
    image: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxmYXNoaW9ufGVufDB8fHx8MTc2MTMzMjYzOHww&ixlib=rb-4.1.0&q=85',
    description: 'Fashion that fits your style'
  },
  {
    id: '3',
    name: 'Home Furnishings',
    image: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxob21lJTIwZGVjb3J8ZW58MHx8fHwxNzYxMzc5MzQ0fDA&ixlib=rb-4.1.0&q=85',
    description: 'Transform your living space'
  },
  {
    id: '4',
    name: 'Furniture',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxmdXJuaXR1cmV8ZW58MHx8fHwxNzYxNDQwMjIzfDA&ixlib=rb-4.1.0&q=85',
    description: 'Quality furniture for every room'
  }
];

export const mockTestimonials = [
  {
    id: '1',
    name: 'Sneha Kapoor',
    role: 'Gen Z Customer',
    content: 'Finally, a platform that shows me exactly where my money goes! The transparency is refreshing.',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  {
    id: '2',
    name: 'Amit Verma',
    role: 'Designer',
    content: 'As a designer, Youseful gives me a platform to showcase my work and earn lifetime royalties. Game changer!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=13'
  },
  {
    id: '3',
    name: 'Ritu Malhotra',
    role: 'Micro Investor',
    content: 'I invested in products I believe in and earned returns. It\'s exciting to be part of this journey!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=5'
  }
];

export const mockOrders = [
  {
    id: 'ORD001',
    date: '2025-01-15',
    total: 4798,
    status: 'Delivered',
    items: [
      { productId: '1', quantity: 1, price: 2499 },
      { productId: '3', quantity: 2, price: 399 }
    ]
  }
];
